export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';

export const COMMON_DATE_FORMAT = 'MM/DD/YYYY';

export enum TimezoneDisplay {
  'America/Anchorage' = 'Alaska Time',
  'America/Phoenix' = 'Mountain Standard Time',
  'America/Chicago' = 'Central Time',
  'America/New_York' = 'Eastern Time',
  'Pacific/Honolulu' = 'Hawaii Standard Time',
  'America/Denver' = 'Mountain Time',
  'America/Los_Angeles' = 'Pacific Time',
}

/**
 * Returns an array of TimezoneDisplay's keys
 * Example: ['America/Anchorage', 'America/Phoenix', ...]
 */
export const SUPPORTED_TIMEZONES = Object.keys(TimezoneDisplay) as (keyof typeof TimezoneDisplay)[];

/**
 * Returns a user-friendly timezone name based on the IANA timezone string.
 * If a friendly name is not found in the `TimezoneDisplay` map, the original IANA timezone string is returned.
 *
 * @param ianaTimezone - The IANA timezone string (e.g., 'America/Los_Angeles').
 * @returns A user-friendly timezone name or the original IANA timezone string if a friendly name is not found. (e.g. "Pacific Time")
 */
export function getFriendlyTimezoneName(ianaTimezone: string): string {
  return TimezoneDisplay[ianaTimezone as keyof typeof TimezoneDisplay] || ianaTimezone;
}

export const DAYS_OF_WEEK_OPTIONS = [
  { label: 'Monday', value: 'monday' },
  { label: 'Tuesday', value: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday' },
  { label: 'Thursday', value: 'thursday' },
  { label: 'Friday', value: 'friday' },
  { label: 'Saturday', value: 'saturday' },
  { label: 'Sunday', value: 'sunday' },
];
